import React, { useEffect } from 'react';
import { ONBOARDING_LOGOUT_LOGGING_OUT } from '../../../constants/Copy';
import Spinner from '../../common/spinner/Spinner';
import { getSubscriptionClient } from '../../../api/subscriptionService';
import { getAccountClient } from '../../../api/accountService';

const Logout = ({ logout }) => {
	const videolandSubscriptionApiClient = getSubscriptionClient();
	const accountClient = getAccountClient();

	useEffect(() => {
		logout().then(() => {
			videolandSubscriptionApiClient.resetStore();
			accountClient.resetStore();
		});
	}, [logout, videolandSubscriptionApiClient, accountClient]);

	return (
		<div className="onboarding__logout">
			<Spinner strokeWidth="4" />
			<span>{ONBOARDING_LOGOUT_LOGGING_OUT}</span>
		</div>
	);
};

export default Logout;
